import React from 'react';
import { Link } from 'react-router-dom';
import logobk from '../../assets/logos/logo-bk.svg';

function BKlogo() {
  return (
    <div>
      <Link to="/restaurants">
        <img src={logobk} alt="logobk" />
      </Link>
    </div>
  );
}

export default BKlogo;
